import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NipponResumeUpload from './NipponResumeUpload';
import BotInterviewUpload from './BotInterviewUpload';
import BotInterviewLinkUpload from './BotInterviewLinkUpload';
import NipponBotInteractionsTable from './NipponBotInteractionsTable';
import axiosInstance from '../../../services/axiosInterceptors';
import nipponBotApiEndpoints from '../../../services/nipponBotApiEndpoints';

export default function BotInterviewsWorkspace({ onMessage, onRefresh }) {
  const [mode, setMode] = useState('files');
  const [generating, setGenerating] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const handleGenerateReports = async () => {
    setGenerating(true);
    try {
      const response = await axiosInstance.post(
        nipponBotApiEndpoints.generateReports,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const queuedCount = response?.data?.data?.queuedCount || 0;
      onMessage(`Queued ${queuedCount} recording${queuedCount === 1 ? '' : 's'} for report generation.`, 'success');
      onRefresh();
    } catch (error) {
      onMessage(error?.response?.data?.status?.value || 'Failed to queue bot interview reports.', 'error');
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button variant={mode === 'files' ? 'contained' : 'outlined'} onClick={() => setMode('files')} sx={{ textTransform: 'none' }}>
            Upload Files
          </Button>
          <Button variant={mode === 'links' ? 'contained' : 'outlined'} onClick={() => setMode('links')} sx={{ textTransform: 'none' }}>
            Upload Audio Links
          </Button>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button variant='outlined' onClick={handleGenerateReports} disabled={generating} sx={{ textTransform: 'none' }}>
            {generating ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
            {generating ? 'Generating...' : 'Generate Reports'}
          </Button>
          <Button variant='contained' onClick={() => navigate('/user/bot-interviews/compiled-report')} sx={{ textTransform: 'none' }}>
            View Compiled Report
          </Button>
        </Box>
      </Box>
      <NipponResumeUpload onMessage={onMessage} onComplete={onRefresh} />
      {mode === 'files'
        ? <BotInterviewUpload onComplete={onRefresh} onMessage={onMessage} />
        : <BotInterviewLinkUpload onComplete={onRefresh} onMessage={onMessage} />}
      <NipponBotInteractionsTable />
    </Box>
  );
}
